'use client'

import { Icon } from '@repo/ui/components'
import type { ShareInlineProps } from './share-inline.types'

export const ShareInline = ({
  url,
  text,
  iconSize = 'xs',
  iconColor = 'fill-neutral-surface-100',
}: ShareInlineProps) => {
  const handleShare = (platform: string) => {
    switch (platform) {
      case 'telegram':
        window.open(
          `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`,
        )
        break
      case 'whatsapp':
        window.open(`https://wa.me/?text=${encodeURIComponent(text)}`)
        break
      case 'twitter':
        window.open(
          `https://x.com/intent/tweet?text=${encodeURIComponent(text)}`,
        )
        break
      case 'instagram':
        // Instagram doesn't have direct sharing URL, so we'll use native share
        if (navigator.share) {
          navigator
            .share({
              title: text,
              // url: url,
            })
            .catch(() => {
              // Fallback if share fails
            })
        }
        break
    }
  }

  return (
    <div className='flex justify-center gap-xs px-md pb-md'>
      <button
        onClick={() => handleShare('whatsapp')}
        className='w-8 h-8 bg-neutral-surface-5 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-neutral-surface-60 transition-colors'
      >
        <Icon name='WhatsappFill' size={iconSize} color={iconColor} />
      </button>

      <button
        onClick={() => handleShare('telegram')}
        className='w-8 h-8 bg-neutral-surface-5 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-neutral-surface-60 transition-colors'
      >
        <Icon name='TelegramFill' size={iconSize} color={iconColor} />
      </button>
      <button
        onClick={() => handleShare('twitter')}
        className='w-8 h-8 bg-neutral-surface-5 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-neutral-surface-60 transition-colors'
      >
        <Icon name='X' size={iconSize} color={iconColor} />
      </button>
      <button
        onClick={() => handleShare('instagram')}
        className='w-8 h-8 bg-neutral-surface-5 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-neutral-surface-60 transition-colors'
      >
        <Icon name='ShareAndroid' size={iconSize} color={iconColor} />
      </button>
    </div>
  )
}
